export default __webpack_public_path__ + "static/media/itwuxp.da249a82.png";